
import type { ToolMessages } from '../../models'
import { defineComponent, getCurrentInstance } from 'vue'
import { EpbButton } from '../shared/epb-button'
export type ToolingFormLayoutSection = 'details' | 'filters' | 'settings' | 'preview'

export default defineComponent({
  name: 'ToolingFormActionButtons',
  components: {
    EpbButton,
  },
  props: {
    readonly: {
      type: Boolean,
    },
    acceptActionDisabled: {
      type: Boolean,
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['accept', 'cancel', 'exit'],
  setup() {
    const baseClass = 'epb-tooling-form-action-buttons'

    const {
      proxy: { $epb },
    } = getCurrentInstance()

    // Action buttons only need the shared actions labels, present in any tool messages
    const messages: ToolMessages = $epb.messages.tools.promotions

    return {
      baseClass,
      messages,
    }
  },
})
